import React from "react";

/**
 * Inline SVG filter that removes near-white pixels from raster images,
 * giving us a clean transparent palm even from a JPEG-with-white-background.
 *
 * Apply with:  style={{ filter: "url(#elio-white-key)" }}
 *
 * Algorithm:
 *   alpha_out = clamp(0, 1,  -R - G - B + 3)   ← from a 4x5 color matrix
 *   White  (1,1,1) → alpha 0  (transparent)
 *   Mid    (0.5,)  → alpha 1.5 → clamped 1 (opaque)
 *   Green  (.2,.6,.2) → alpha 2 → clamped 1 (opaque)
 * The slight near-white pixels at palm edges fade smoothly between 0..1,
 * which keeps the silhouette soft (no jaggies).
 */
const WhiteKeyFilter = () => (
  <svg
    aria-hidden="true"
    width="0"
    height="0"
    style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
  >
    <defs>
      <filter
        id="elio-white-key"
        colorInterpolationFilters="sRGB"
        x="0"
        y="0"
        width="100%"
        height="100%"
      >
        {/* Aggressive near-white removal so watercolor halos disappear cleanly.
            alpha = clamp(0,1,  -1.9R -1.9G -1.9B + 4.6)
              White       (1,1,1)        → -1.1 → 0  (transparent)
              Off-white   (0.96,...)     → -0.872 → 0
              Light gray  (0.85,...)     → -0.245 → 0
              Mid gray    (0.7,...)      → 0.61  → 0.61 (soft)
              Green palm  (.3,.55,.3)    → 2.32  → 1   (opaque)
              Brown trunk (.45,.3,.15)   → 2.92  → 1   (opaque)  */}
        <feColorMatrix
          type="matrix"
          values="
            1 0 0 0 0
            0 1 0 0 0
            0 0 1 0 0
            -1.9 -1.9 -1.9 0 4.6
          "
        />
      </filter>

      {/* A second filter that turns the palm into a dark silhouette,
          handy for sections where the palm sits over a dark photo and we
          want zero risk of bright edge halos. */}
      <filter
        id="elio-silhouette"
        colorInterpolationFilters="sRGB"
        x="0"
        y="0"
        width="100%"
        height="100%"
      >
        <feColorMatrix
          type="matrix"
          values="
            0 0 0 0 0.06
            0 0 0 0 0.10
            0 0 0 0 0.08
            -1.9 -1.9 -1.9 0 4.6
          "
        />
      </filter>
    </defs>
  </svg>
);

export default WhiteKeyFilter;
